<template>
  <div style="height: 440px; width: 350px;">
    <div style="height: 400px; width: 350px; overflow-y: auto;" ref="stickerContainer">
      <div v-for="(stick, index) in dataSticker" :key="index" :ref="`category-${index}`">
        <div class="title-sticker">{{ stick.category?.name }}</div>
        <div class="sticker-container">
          <div v-for="st in stick.stickers" :key="st.id" class="sticker-item"
            @click="sendSticker(stick.category.id, st.id, st.source, st.type)">
            <el-image class="" :src="`https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=${st.id}&size=130`" />
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex" ref="categoryWrapper" style="padding-top: 10px; margin-bottom: -5px;">
      <button class="arrow-button" @click="scrollCategories('left')">◀</button>
      <div class="category-list" ref="categoryList">
        <div v-for="(stick, index) in dataSticker" :key="index" class="category-button"
          @click="scrollToCategory(index)">
          <el-image class="" :src="`${stick.category?.iconPreview}`" />
        </div>
      </div>
      <button class="arrow-button" @click="scrollCategories('right')">▶</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataSticker"],
  data() {
    return {
    }
  },
  methods: {
    scrollToCategory(index) {
      const categoryElement = this.$refs[`category-${index}`][0];
      const container = this.$refs.stickerContainer;

      if (categoryElement && container) {
        container.scrollTo({
          top: categoryElement.offsetTop,
          behavior: "smooth",
        });
      }
    },
    scrollCategories(direction) {
      const list = this.$refs.categoryList;
      if (!list) return;

      const scrollAmount = 100;
      if (direction === "left") {
        list.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      } else if (direction === "right") {
        list.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    },
    sendSticker(cateId, stickerId, source, type) {
      let request = {
        cateId: cateId,
        stickerId: stickerId,
        source: source,
        type: type
      }
      this.$emit("sendSticker", request);
    }
  },
}
</script>

<style scoped>
.sticker-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}

.sticker-item {
  flex: 1 1 calc(25% - 10px);
  max-width: calc(25% - 10px);
  box-sizing: border-box;
  background-color: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title-sticker {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 16px;
}

.sticker-item:hover {
  cursor: pointer;
  background-color: #e0e0e0;
  box-shadow: #CCCCCC 1px 1px;
  border-radius: 4px;
}

.category-list {
  display: flex;
  overflow-x: auto;
  overflow: hidden;
  scroll-behavior: smooth;
  white-space: nowrap;
  gap: 10px;
  flex-grow: 1;
}

/* Nút category */
.category-button {
  flex: 1 1 calc(25% - 10px);
  max-width: calc(25% - 35px);
  padding: 0;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.category-button:hover {
  background-color: #e0e0e0;
}

/* Nút mũi tên cuộn */
.arrow-button {
  background-color: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 5px;
}

.arrow-button:hover {
  color: #007bff;
}
</style>